import React, { useEffect, useState } from "react";
import {
  Container,
  Content,
  Header,
  Title,
  CloseButton,
  CloseIcon,
  Body,
} from "./style";
import { useModal, useHideModal } from "../../hooks";
import Spinner from "../Spinner";
import { useDispatch } from "react-redux";
import { clearState } from "../../redux/modules/modalwork/actions";

export default () => {
  const { blured: modal, loading } = useModal();
  const { hideModal } = useHideModal();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (modal.show) {
      setIsOpen(true);
    }
  }, [modal.show]);

  const handleCloseModal = () => {
    setTimeout(() => {
      dispatch(clearState());
      hideModal();
    }, 300);
    setIsOpen(false);
  };

  return (
    <Container show={modal.show}>
      <Content maxWidth={modal.maxWidth} show={isOpen}>
        <Header>
          <Title className="noselect">{modal.title || ""}</Title>
          <CloseButton onClick={handleCloseModal}>
            <CloseIcon />
          </CloseButton>
        </Header>
        <Body maxHeight={modal.maxHeight} overflow={modal.overflow}>
          {loading ? (
            <Spinner maxHeight={"100%"} />
          ) : (
            (modal.body && <modal.body />) || "Body"
          )}
        </Body>
      </Content>
    </Container>
  );
};
